import { useTranslation } from "react-i18next";
import { dateFormat } from "util/commAction";
import { getDateInf } from "components/calendar/action";
import BookInfCalendar from "./calendar";
import { useBookInfContext } from "components/context/bookInfContext";
import "./bkCalendar.scss";

export default function BkCalendar() {
  const { t } = useTranslation();
  const { bkStep, bookInf, calendarOpen, setCalendarOpen } =
    useBookInfContext();
  const { today, tomorrow } = getDateInf(new Date());

  const handleClose = () => {
    setCalendarOpen("");
  };

  return (
    <div className={"book-calendar" + " " + calendarOpen}>
      <div className="calendar-op">
        <button
          className={
            "btn-date" + " " + (bkStep !== 1 ? "border-transparent" : "")
          }
          onClick={() => {
            if (calendarOpen === "first") {
              setCalendarOpen("");
            }
            if (calendarOpen !== "first") {
              setCalendarOpen("first");
            }
          }}
          disabled={bkStep !== 1}
        >
          <h6>{t("txt_chck_in_cmm")}</h6>
          {/* <h3 className="sub">{dateFormat(bookInf?.dates[0] || today, ".")}</h3> */}
          <h3 className="sub">{dateFormat(bookInf?.dates[0] || today, ".")}</h3>
        </button>
        <button
          className={
            "btn-date" + " " + (bkStep !== 1 ? "border-transparent" : "")
          }
          onClick={() => {
            if (calendarOpen === "last") {
              setCalendarOpen("");
            }
            if (calendarOpen !== "last") {
              setCalendarOpen("last");
            }
          }}
          disabled={bkStep !== 1}
        >
          <h6>{t("txt_chck_out_cmm")}</h6>
          <h3 className="sub">
            {dateFormat(bookInf?.dates[1] || tomorrow, ".")}
          </h3>
        </button>
        <div className="border-overlay"></div>
      </div>
      <BookInfCalendar handleClose={handleClose} />
    </div>
  );
}
